import { imageStore } from '../images.js';
import Drawable from '../entities/Drawable.js';
import Sprite from './Sprite.js';
import PixelText from './PixelText.js';
import TypeBadge from './TypeBadge.js';

export default class NewMoveMenu extends Drawable {
    constructor({ position = { x: 0, y: 0 }, pokemon = null, visible = false, newMove }) {
        super();
        this.position = position;
        this.selectedMove = 0;
        this.pokemon = pokemon;
        this.visible = visible;

        this.move0Text = new PixelText({
            text: this.pokemon?.moves[0]?.name || '--',
            position: { x: this.position.x + 240 - 8, y: this.position.y + 32 - 7 },
            color: 'black',
            textAlign: 'right',
        });

        this.move0PPText = new PixelText({
            text: `PP${this.pokemon?.moves[0]?.pp || '--'}/${this.pokemon?.moves[0]?.maxPP || '--'}`,
            position: {
                x: this.position.x + 240 - 8,
                y: this.position.y + 32 + 9 - 7,
            },
            color: 'black',
            textAlign: 'right',
        });

        this.move1Text = new PixelText({
            text: this.pokemon?.moves[1]?.name || '--',
            position: {
                x: this.position.x + 240 - 8,
                y: this.position.y + 32 + 28 - 7,
            },
            color: 'black',
            textAlign: 'right',
        });

        this.move1PPText = new PixelText({
            text: `PP${this.pokemon?.moves[1]?.pp || '--'}/${this.pokemon?.moves[1]?.maxPP || '--'}`,
            position: {
                x: this.position.x + 240 - 8,
                y: this.position.y + 32 + 37 - 7,
            },
            color: 'black',
            textAlign: 'right',
        });

        this.move2Text = new PixelText({
            text: this.pokemon?.moves[2]?.name || '--',
            position: {
                x: this.position.x + 240 - 8,
                y: this.position.y + 32 + 56 - 7,
            },
            color: 'black',
            textAlign: 'right',
        });

        this.move2PPText = new PixelText({
            text: `PP${this.pokemon?.moves[2]?.pp || '--'}/${this.pokemon?.moves[2]?.maxPP || '--'}`,
            position: {
                x: this.position.x + 240 - 8,
                y: this.position.y + 32 + 65 - 7,
            },
            color: 'black',
            textAlign: 'right',
        });

        this.move3Text = new PixelText({
            text: this.pokemon?.moves[3]?.name || '--',
            position: {
                x: this.position.x + 240 - 8,
                y: this.position.y + 32 + 84 - 7,
            },
            color: 'black',
            textAlign: 'right',
        });

        this.move3PPText = new PixelText({
            text: `PP${this.pokemon?.moves[3]?.pp || '--'}/${this.pokemon?.moves[3]?.maxPP || '--'}`,
            position: {
                x: this.position.x + 240 - 8,
                y: this.position.y + 32 + 93 - 7,
            },
            color: 'black',
            textAlign: 'right',
        });

        this.move4Text = new PixelText({
            text: this.pokemon?.newMoves[0]?.name || '--',
            position: {
                x: this.position.x + 240 - 8,
                y: this.position.y + 32 + 112 - 7,
            },
            color: 'black',
            textAlign: 'right',
        });

        this.move4PPText = new PixelText({
            text: `PP${this.pokemon?.newMoves[0]?.pp || '--'}/${this.pokemon?.newMoves[0]?.maxPP || '--'}`,
            position: {
                x: this.position.x + 240 - 8,
                y: this.position.y + 32 + 121 - 7,
            },
            color: 'black',
            textAlign: 'right',
        });

        this.move0TypeBadge = new TypeBadge({
            position: {
                x: this.position.x + 120 + 12,
                y: this.position.y + 16 + 9,
            },
            type: this.pokemon?.moves[0]?.type || 'blank',
        });

        this.move1TypeBadge = new TypeBadge({
            position: {
                x: this.position.x + 120 + 12,
                y: this.position.y + 16 + 37,
            },
            type: this.pokemon?.moves[1]?.type || 'blank',
        });

        this.move2TypeBadge = new TypeBadge({
            position: {
                x: this.position.x + 120 + 12,
                y: this.position.y + 16 + 65,
            },
            type: this.pokemon?.moves[2]?.type || 'blank',
        });

        this.move3TypeBadge = new TypeBadge({
            position: {
                x: this.position.x + 120 + 12,
                y: this.position.y + 16 + 93,
            },
            type: this.pokemon?.moves[3]?.type || 'blank',
        });

        this.move4TypeBadge = new TypeBadge({
            position: {
                x: this.position.x + 120 + 12,
                y: this.position.y + 16 + 121,
            },
            type: this.pokemon?.newMoves[0]?.type || 'blank',
        });

        this.cancelText = new PixelText({
            text: 'CANCEL',
            position: { x: 200, y: this.position.y + 148 - 7 },
            textAlign: 'right',
            color: 'black',
        });

        this.movePowerText = new PixelText({
            text: '--',
            position: { x: this.position.x + 59, y: this.position.y + 67 - 7 },
            textAlign: 'left',
            color: 'black',
        });

        this.moveAccuracyText = new PixelText({
            text: '--',
            position: { x: this.position.x + 59, y: this.position.y + 67 + 14 - 7 },
            textAlign: 'left',
            color: 'black',
        });

        this.moveDescriptionText = new PixelText({
            text: '',
            maxWidth: 100,
            position: { x: this.position.x + 8, y: this.position.y + 108 - 7 },
            textAlign: 'left',
            color: 'black',
        });

        this.selectedMoveBox = new Sprite({
            position: { x: 0, y: 0 },
            image: imageStore.get('img/selected_move_box.png'),
            visible: false,
            frames: { max: 1, val: 0 },
            moving: false,
        });

        this.currentPokemonIcon = this.pokemon?.icon;
        // this.currentPokemonIcon.position = { x: 0, y: 16 };
        // this.currentPokemonIcon.spriteIndex = this.pokemon.id - 1;

        this.background = new Sprite({
            position: { x: 0, y: 0 },
            image: imageStore.get('img/new_move_menu.png'),
            visible: true,
            frames: { max: 1, val: 0 },
            moving: false,
        });

        this.movePowerText = new PixelText({
            text: '--',
            position: { x: this.position.x + 59, y: this.position.y + 67 - 7 },
            textAlign: 'left',
            color: 'black',
        });

        this.moveAccuracyText = new PixelText({
            text: '--',
            position: { x: this.position.x + 59, y: this.position.y + 67 + 14 - 7 },
            textAlign: 'left',
            color: 'black',
        });

        this.moveDescriptionText = new PixelText({
            text: '',
            maxWidth: 100,
            position: { x: this.position.x + 8, y: this.position.y + 108 - 7 },
            textAlign: 'left',
            color: 'black',
        });
        this.newMove = newMove;
        this.currentMovesList = [
            this.pokemon?.moves[0],
            this.pokemon?.moves[1],
            this.pokemon?.moves[2],
            this.pokemon?.moves[3],
            this.newMove,
        ];
    }

    draw() {
        if (this.pokemon === null) {
            return;
        }
        if (!this.visible) {
            return;
        }
        this.currentMovesList = [
            this.pokemon.moves[0],
            this.pokemon.moves[1],
            this.pokemon.moves[2],
            this.pokemon.moves[3],
            this.newMove,
        ];
        this.background.draw();
        this.move0Text.text = this.currentMovesList[0]?.name || '--';
        this.move0PPText.text = `PP ${this.currentMovesList[0]?.pp || '--'}/${
            this.currentMovesList[0]?.maxPP || '--'
        }`;
        this.move1Text.text = this.currentMovesList[1]?.name || '--';
        this.move1PPText.text = `PP ${this.currentMovesList[1]?.pp || '--'}/${
            this.currentMovesList[1]?.maxPP || '--'
        }`;
        this.move2Text.text = this.currentMovesList[2]?.name || '--';
        this.move2PPText.text = `PP ${this.currentMovesList[2]?.pp || '--'}/${
            this.currentMovesList[2]?.maxPP || '--'
        }`;
        this.move3Text.text = this.currentMovesList[3]?.name || '--';
        this.move3PPText.text = `PP ${this.currentMovesList[3]?.pp || '--'}/${
            this.currentMovesList[3]?.maxPP || '--'
        }`;
        this.move4Text.text = this.currentMovesList[4]?.name || '--';
        this.move4PPText.text = `PP ${this.currentMovesList[4]?.pp || '--'}/${
            this.currentMovesList[4]?.maxPP || '--'
        }`;
        const movePower = this.currentMovesList[this.selectedMove]?.power;
        const moveAccuracy = this.currentMovesList[this.selectedMove]?.accuracy;
        this.movePowerText.text = movePower > 0 ? String(movePower) : '--';
        if (this.movePowerText.text.length === 3) {
            this.movePowerText.position.x = this.position.x + 59;
        } else {
            this.movePowerText.position.x = this.position.x + 61;
        }
        this.movePowerText.draw();
        this.moveAccuracyText.text = moveAccuracy > 0 ? String(moveAccuracy) : '--';
        if (this.moveAccuracyText.text.length === 3) {
            this.moveAccuracyText.position.x = this.position.x + 59;
        } else {
            this.moveAccuracyText.position.x = this.position.x + 61;
        }
        this.moveAccuracyText.draw();

        this.moveDescriptionText.text = this.currentMovesList[this.selectedMove]?.effect || '';
        this.moveDescriptionText.draw();

        this.move0TypeBadge.type = this.currentMovesList[0]?.type || 'blank';
        this.move0TypeBadge.draw();
        this.move1TypeBadge.type = this.currentMovesList[1]?.type || 'blank';
        this.move1TypeBadge.draw();
        this.move2TypeBadge.type = this.currentMovesList[2]?.type || 'blank';
        this.move2TypeBadge.draw();
        this.move3TypeBadge.type = this.currentMovesList[3]?.type || 'blank';
        this.move3TypeBadge.draw();
        this.move4TypeBadge.type = this.currentMovesList[4]?.type || 'blank';
        this.move4TypeBadge.draw();

        this.move0Text.draw();
        this.move0PPText.draw();
        this.move1Text.draw();
        this.move1PPText.draw();
        this.move2Text.draw();
        this.move2PPText.draw();
        this.move3Text.draw();
        this.move3PPText.draw();
        this.move4Text.draw();
        this.move4PPText.draw();

        this.currentPokemonIcon = this.pokemon.icon;
        this.currentPokemonIcon.position = { x: 0, y: 16 };
        this.currentPokemonIcon.visible = true;
        this.currentPokemonIcon.spriteIndex = this.pokemon.id - 1;
        this.currentPokemonIcon.draw();

        this.selectedMoveBox.visible = true;
        this.selectedMoveBox.position = {
            x: 128,
            y: 22 + 28 * this.selectedMove,
        };
        this.selectedMoveBox.draw();
    }
}
